module.exports = __webpack_public_path__ + "media/images/moon-e94010285afd2114ff7a60a9958be307.png";